import { parseSchedule } from '@/store/utils'
import { RES_SCHEDULE_STATUS, RES_STATUS } from '@/helpers/ResHelper'
// **************************************************
//
// LOADING
//
// **************************************************
export const setLoadProgress = (state, progress) => {
  state.loading.progress = Math.min(progress, 1)
}
export const setLoadStep = (state, step) => {
  state.loading.step = step
  console.log('setLoadStep', step)
}
export const setLoadComplete = (state) => {
  state.loading.progress = 1
  state.loading.completed = true
}
export const setSysInfo = (state, sysInfo) => {
  //state.sysInfo.sysBarHeight = sysInfo.sysBarHeight
  console.log('got sysinfo', sysInfo)
  if (sysInfo) state.sysInfo = sysInfo
}
export const setSafePadding = (state, safePadding) => {
  state.resize.safePadding = safePadding
}
export const setRouterBack = (state, routerBack) => {
  console.log('setRouterBack', routerBack)
  state.router.back = routerBack
}
export const setRouterLast = (state, routerLast) => {
  console.log('setRouterBack', routerLast)
  state.router.last = routerLast
}
export const addAdult = (state, adult) => {
  state.fam.adult = adult
}

/*
0-----normal
1-----resed
2-----checkedIn
 */
export const updateUserInfo = (state, user) => {
  console.log('user info update set', user)
  state.appStatus = 0
  let activeCnt = 0
  if (user.reses && user.reses.length > 0) {
    user.reses.map((r) => {
      // if (
      //   r.resStatus === RES_STATUS.RESCHEDULED ||
      //   r.resStatus === RES_STATUS.CREATED
      // ) {
      //   activeCnt++
      // }
      if (
        r.resStatus === RES_STATUS.RESCHEDULED ||
        r.resStatus === RES_STATUS.CREATED
      ) {
        if (r.resScheduleStatus !== RES_SCHEDULE_STATUS.PASSED) activeCnt++
      }
    })
  }
  //UPDATE CHECKIN STATUS
  if (activeCnt > 0) state.appStatus = 1
  if (user.checkin && user.checkin.status === 0) state.appStatus = 2

  state.user = user
}

export const setAppStatus = (state, appStatus) => {
  console.log('app status set', appStatus)
  state.appStatus = appStatus
}

// export const setScheduleTable = (state, schedulesRaw) => {
//   console.log('user info update set', schedulesRaw)
//   state.scheduleTable = resolveScheduleRawData(schedulesRaw)
// }

export const setCalenders = (state, calenders) => {
  console.log('mutation', calenders)
  state.calenders = resolveCalendersRawData(calenders)
  console.log('calenders set', resolveCalendersRawData(calenders))
}

export const setSchedulePicked = (state, schedule) => {
  console.log('mutation', schedule)
  state.schedulePicked = schedule
  console.log('schedule set', schedule)
}

export const setTicketPicked = (state, ticket) => {
  state.ticketPicked = ticket
  console.log('ticket set', ticket)
}

function resolveCalendersRawData(raw) {
  let days = []
  for (let i = 0; i < raw.length; i++) {
    if (raw[i].calenderStatus != 1) {
      let day = {
        id: raw[i].calenderDate,
        date: new Date(raw[i].calenderDate),
        status: raw[i].calenderStatus,
      }
      days.push(day)
    }
  }
  return days
}

export const setSchedules = (state, schedules) => {
  console.log('mutation', schedules)
  state.schedules = resolveSchedulesRawData(schedules)
  console.log('calenders set')
}

function resolveSchedulesRawData(raw) {
  let schedules = []
  for (let s in raw) {
    //console.log(s, raw[s])
    let schedule = parseSchedule(s, raw[s])
    schedules.push(schedule)
  }
  return schedules
}

export const setInvInfo = (state, payload) => {
  state.invCode = payload.invCode
  state.inviter = payload.inviter
  state.showInvPopup = true
}
export const setShowInvPopup = (state, show) => {
  state.showInvPopup = show
}

export const invInfoClear = (state) => {
  state.invCode = null
  state.inviter = null
  state.showInvPopup = false
}

// function resolveScheduleRawData(raw) {
//   let days = []
//   for (let i = 0; i < raw.length / 4; i++) {
//     let schedules = []
//     for (let j = 0; j < 4; j++) {
//       let schedule = raw[i * 4 + j]
//       let strs = schedule.scheduleId.split('-')
//       let from = new Date(Number.parseInt(strs[0]))
//       let to = new Date(Number.parseInt(strs[1]))
//       schedule.from = from
//       schedule.to = to
//       schedules.push(schedule)
//     }
//     let day = {
//       date: new Date(raw[i * 4].scheduleDate),
//       schedules: schedules,
//     }
//     days.push(day)
//   }
//   return days
// }

export const setPending = (state, pending) => {
  state.pending = pending
}

export const showAgeWarning = (state) => {
  state.ageWarning = true
}
export const ageWarningConfirm = (state) => {
  state.ageWarningShowed = true
}
export const resetWarning = (state) => {
  state.ageWarning = false
  state.ageWarningShowed = false
}
export const toggleQueuePanel = (state, show) => {
  state.showQueuePanel = show
}

export const setShowLatestResPopup = (state, show) => {
  state.showLatestResPopup = show
}

export const setShowCharityPopup = (state, show) => {
  state.showCharityPopup = show
}

export const setMpEventList = (state, list) => {
  state.mpEventList = list
}

export const setFootprintTaskListToday = (state, data) => {
  state.footprintTaskListToday = data
}

export const setFootprintServiceTime = (state, data) => {
  state.footprintServiceTime = data
}

export const setFootprintCreateQRCodeStr = (state, data) => {
  state.footprintQrcode = data
}
// // **************************************************
// //
// // ROUTE
// //
// // **************************************************
// export const setRoute = (state, params) => {
//   state.route.prev.parent = state.route.curr.parent
//   state.route.prev.child = state.route.curr.child

//   state.route.curr.parent = params.parent
//   state.route.curr.child = params.child

//   state.app_state = params.child ? params.child : params.parent
// }

// export const setRouteAfterLoad = (state, value) => {
//   console.log('setafterload', value)
//   state.route.afterLoad = value
// }

// // **************************************************
// //
// // GATES
// //
// // **************************************************
// export const setPassedAgeGate = (state) => {
//   state.passedAgeGate = true
//   window.localStorage.setItem('_passedAgeGate', true)
// }

// export const setPassedTermsGate = (state) => {
//   state.passedTermsGate = true
//   window.localStorage.setItem('_passedTermsGate', true)
// }

// // **************************************************
// //
// // UI
// //
// // **************************************************
// export const setTapped = (state) => {
//   state.tapped = true
// }

// export const toggleMuted = (state) => {
//   state.muted = !state.muted
//   MediaService.muted = state.muted
// }

// export const toggleSubtitles = (state) => {
//   state.showSubtitles = !state.showSubtitles
// }

// export const setMode = (state, mode) => {
//   state.mode = mode
// }
// export const toggleMode = (state) => {
//   state.mode = 1-state.mode
//   if (state.mode === 1)
//     AnalyticsService.sendPageview('/scene/kids')
//   else
//     AnalyticsService.sendPageview('/scene/adults')
// }

// export const setSceneProgress = (state, sceneProgress) => {
//   state.sceneProgress = sceneProgress
// }
// export const setMapProgress = (state, mapProgress) => {
//   state.mapProgress = mapProgress
// }

// export const addToGallery = (state, img) => {
//   state.gallery.unshift(img)
// }

// export const openMenu = (state) => {
//   state.showMenu = true
//   state.modeLock = true
//   AnalyticsService.sendEvent('menu', 'click', `button-menu`)
// }
// export const closeMenu = (state) => {
//   state.showMenu = false
//   state.modeLock = false
// }

// export const toggleDestInfo = (state) => {
//   state.showDestInfo = !state.showDestInfo
// }

// export const openGallery = (state) => {
//   state.showGallery = true
//   state.modeLock = true
// }
// export const closeGallery = (state) => {
//   state.showGallery = false
//   state.modeLock = false
// }

// export const openQRPage = (state) => {
//   state.showQRPage = true
// }
// export const closeQRPage = (state) => {
//   state.showQRPage = false
// }

// export const setLoadAframe = (state, val) => {
//   state.loadAframe = val
// }
// export const setLoadScene = (state, val) => {
//   state.loadScene = val
// }
// export const setSceneLoadProgress = (state, sceneProgress) => {
//   state.loadSceneProgress = sceneProgress
// }
// export const setCamZoom = (state, val) => {
//   state.camZoom = val
// }
// export const setCamDistort = (state, val) => {
//   state.camDistort = val
// }

// export const setSceneEntered = (state, val) => {
//   state.sceneEntered = val
// }
// export const setSceneComplete = (state, val) => {
//   state.sceneComplete = val
// }

// export const setCurrSceneIdx = (state, val) => {
//   state.currSceneIdx = val
// }

// export const setModeSwitching = (state, val) => {
//   state.modeSwitching = val
// }

// export const lockMode = (state) => {
//   state.modeLock = true
// }
// export const unlockMode = (state) => {
//   state.modeLock = false
// }
// export const setBgm = (state, bgm) => {
//   state.bgm = bgm
// }
// export const playBgm = (state) => {
//   state.bgm.play()
// }
// export const pauseBgm = (state) => {
//   state.bgm.pause()
// }

// export const setTutorProgress = (state, val) => {
//   state.tutorProgress = val
// }
// export const setTutorTouchX = (state, val) => {
//   state.tutorTouchX = val
// }
// export const setTutorTouchY = (state, val) => {
//   state.tutorTouchY = val
// }
